import { Divider, Grid, Typography } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { Label, LinkS } from '../../../../../../components/UiElements/UiElements'
import { CheckboxField, InputBaseField } from '../../../../../../components/InputField/InputField'
import { PostDataAPI } from '../../../../../../Services/APIService';
import { withSnackbar } from "./../../../../../../components/Message/Alert";
import { formateMdnNumber, maskAccountNumber, maskCreditCardNumber, IsVerizonSIM, saveActivlityLogInfo } from '../../../../../../../src/components/Common/Extensions';
import PersonIcon from '@material-ui/icons/Person';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import EventBusyIcon from '@material-ui/icons/EventBusy';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import { GetUserInfo } from "../../../../../../Services/GetUserInfo";

import useStyles from "./styles";
function ReviewAndAuthorize({ data, handleNext, triggerRevNAuthNext, updateTrigger, simPrice, customerData, setLoaderVisible, setLoaderHide, isPrepaid, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [state, setState] = useState(data);
    let user_info = JSON.parse(GetUserInfo());
    const [customerInfo, setCustomerInfo] = useState(customerData ? customerData : {});
    const [loginUser, setLoginUser] = useState(user_info.user);
    const [accountNumber] = useState(user_info.user.accountNumber);
    const [customerID] = useState(user_info.user.customerID);
    const getCarrierName = () => state.existingCarrier == 'Other' ? state.otherCarrier : state.existingCarrier;
    const maskLast4 = (value) => {
        const digits = (value || "").toString().replace(/\D/g, "");
        if (!digits)
            return "not available";
        return `****${digits.slice(-4)}`;
    };
    const getPortSummary = () => {
        const parts = [];
        if (state.msisdn)
            parts.push(`line ${formateMdnNumber(state.msisdn)}`);
        if (getCarrierName())
            parts.push(`carrier ${getCarrierName()}`);
        if (state.oldCarrierAccountNumber)
            parts.push(`carrier account ${maskLast4(state.oldCarrierAccountNumber)}`);
        if (state.icc || state.ICC)
            parts.push(`SIM ICC ${maskLast4(state.icc || state.ICC)}`);
        if (state.wirelessPlanType || state.packageName || state.activationPlanId)
            parts.push(`plan ${state.wirelessPlanType || state.packageName || state.activationPlanId}`);

        return parts.length > 0 ? parts.join(", ") : `account ${maskAccountNumber(accountNumber)}`;
    };
    const logPortReviewActivity = (activity, details) => {
        saveActivlityLogInfo("Line Management", activity, details, accountNumber, customerID);
    };
    const handleChkboxChange = e => {

        const { name, checked } = e.target;
        logPortReviewActivity(
            name === "authorize" ? "Port In Authorization Updated" : "Port In Agreement Updated",
            `User ${checked ? "checked" : "unchecked"} ${name === "authorize" ? "authorization" : "wireless customer agreement"} for ${getPortSummary()}`
        );
        setState(prevState => ({
            ...prevState,
            [name]: checked
        }));
    }
    const PortNumber = () => {
        if (!state.authorize || !state.agree) {
            logPortReviewActivity(
                "Port In Submit Blocked",
                `User attempted to submit Port In request without required authorization/agreement for ${getPortSummary()}`
            );
            showMessage("Error", "Please authorize and agree to wireless customer agreement", "error", 3000);
            return;
        }
        setLoaderVisible();
        //if (isPrepaid) {
        //    state.activationPlanId = parseInt(state.activationPlanId);
        //}
        //else {
        //    state.packageName = state.activationPlanId;
        //    state.activationPlanId = 0;
        //}
        //state.activationPlanId = state.activationPlanId ? parseInt(state.activationPlanId) : 0;
        state.loginUserName = loginUser.firstName;
        state.accountNumber = loginUser.accountNumber;
        state.cycleDay = 17;


        state.shipName = state.firstName + ' ' + state.lastName;
        state.shipAddress1 = state.address1;
        state.shipAddress2 = state.address2;
        state.shipCity = state.city;
        state.shipState = state.state;
        state.shipZip = state.zip;
        state.shipCountry = "US";
        state.shipPhone = state.phone;
        state.shipContactName = state.firstName + ' ' + state.lastName;


        state.homeAddress1 = state.address1;
        state.homeAddress2 = state.address2;
        state.homeCity = state.city;
        state.homeState = state.state;
        state.homeZip = state.zip;
        state.homeCountry = "US";
        state.homePhone = state.phone;
        state.homeContactName = state.firstName + ' ' + state.lastName;
        debugger;
        var method = "telispire/portANumber";
        if (IsVerizonSIM(state.icc)) {
            method = "verizon/portANumber";

        }
        logPortReviewActivity(
            "Port In Submit Attempted",
            `User submitted Port In request for ${getPortSummary()}`
        );
        PostDataAPI(method, state).then((result) => {
            setLoaderHide()
            if (result.success && result.data != null) {
                handleNext(state);
            } else {
                showMessage("Error", result.message, "error", 3000);
            }
        })
        //}
    }
    useEffect(() => {
        console.log(data)
        console.log(customerInfo)
        if (triggerRevNAuthNext) {
            PortNumber();
            updateTrigger();
        }
    }, [triggerRevNAuthNext]);
    return (
        <>
            <Grid container alignItems='center'>
                <Grid item lg={12} xs={12} sm={12}>
                    <Grid container>
                        <div className={classes.dialogSubHeader}>
                            <h3>Review and Authorize</h3>
                        </div>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item lg={12} xs={12} sm={12}>
                    <Typography className={classes.text}>Switching now <span>{formateMdnNumber(data.msisdn)}</span> from <span>{data.existingCarrier == 'Other' ? data.otherCarrier : data.existingCarrier}</span> to <span>FIGGERS</span> on <span>{data.wirelessPlanType}</span></Typography>
                </Grid>
                {/* <Grid item lg={12}>
                <Divider variant="middle" orientation="horizontal" className={classes.divider} />
            </Grid> */}
                <Grid item lg={12} xs={12} sm={12}>
                    <Grid container >
                        <Grid item sm={12} md={12} lg={6} xl={6} className={classes.containerBox}>
                            <Typography className={classes.title}>{data.existingCarrier == 'Other' ? data.otherCarrier : data.existingCarrier} Information</Typography>
                            <Grid container>
                                <Grid item lg={4}>
                                    <Typography className={classes.labelHeading}>Account Number:</Typography>
                                </Grid>
                                <Grid item lg={8}>
                                    <Typography className={classes.label}>{data.oldCarrierAccountNumber}</Typography>
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item lg={4}>
                                    <Typography className={classes.labelHeading}>PIN Number:</Typography>
                                </Grid>
                                <Grid item lg={8}>
                                    <Typography className={classes.label}>{data.transferPin}</Typography>
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item lg={4}>
                                    <Typography className={classes.labelHeading}>IMEI #:</Typography>
                                </Grid>
                                <Grid item lg={8}>
                                    <Typography className={classes.label}>{data.imei}</Typography>
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item lg={4}>
                                    <Typography className={classes.labelHeading}>SSN #:</Typography>
                                </Grid>
                                <Grid item lg={8}>
                                    <Typography className={classes.label}>*************{data.ssn}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item sm={12} xs={12} md={12} lg={6} xl={6} className={classes.leftPadding}>
                            {isPrepaid ? <>
                                <Typography className={classes.title}>Payment Information</Typography>
                                <Grid container>
                                    <Grid item lg={1} sm={2} xs={2}>
                                        <PersonIcon style={{ color: '#4077ba' }} />
                                    </Grid>
                                    <Grid item lg={10}>
                                        <Typography className={classes.label}>{customerInfo?.billingName}</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item lg={1} sm={2} xs={2}>
                                        <CreditCardIcon style={{ color: '#4077ba' }} />
                                    </Grid>
                                    <Grid item lg={10}>
                                        <Typography className={classes.label}>{maskCreditCardNumber(customerInfo?.creditCardNumber)}</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item lg={1} sm={2} xs={2}>
                                        <ConfirmationNumberIcon style={{ color: '#4077ba' }} />
                                    </Grid>
                                    <Grid item lg={10}>
                                        <Typography className={classes.label}>{customerInfo?.creditCardExpirationCvv}</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item lg={1} sm={2} xs={2}>
                                        <EventBusyIcon style={{ color: '#4077ba' }} />
                                    </Grid>
                                    <Grid item lg={10}>
                                        <Typography className={classes.label}>{customerInfo?.creditCardExpiration}</Typography>
                                    </Grid>
                                </Grid>
                            </> : <></>}
                        </Grid>
                    </Grid>
                    <Grid item lg={12}>
                        <CheckboxField
                            color="primary"
                            onChange={handleChkboxChange}
                            name="authorize"
                            checked={state.authorize}
                            label="I authorize to transfer my phone number to Figgers Communication Inc."
                        />
                    </Grid>
                    <Grid item lg={12}>
                        <CheckboxField
                            color="primary"
                            onChange={handleChkboxChange}
                            name="agree"
                            checked={state.agree}
                            label="I agree to Wireless Customer Agreement"
                        />
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}
export default withSnackbar(ReviewAndAuthorize);
